<template>
  <div class="addSupplierDelivery">
    <el-form
      label-width="120px"
      :model="formInline"
      :rules="formInlineRules"
      ref="formInline"
      :validate-on-rule-change="false"
      :disabled="true"
    >
      <div class="topFrom" ref="sub">
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.shippingInstruction')"
              prop="instructionNo"
            >
              <el-input v-model="formInline.instructionNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.createData')"
              prop="instructionCreateDate"
            >
              <el-date-picker
                class="inputWidth"
                disabled
                v-model="formInline.instructionCreateDate"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.instructionStatus')"
              prop="instructionStatus"
            >
              <el-select
                class="inputWidth"
                v-model="formInline.instructionStatus"
                disabled
                filterable
              >
                <el-option :label="$t('addSupplierDelivery.option.save')" value="0"></el-option>
                <el-option :label="$t('addSupplierDelivery.option.sure')" value="1"></el-option>
                <el-option :label="$t('addSupplierDelivery.option.toStore')" value="2"></el-option>
                <el-option :label="$t('addSupplierDelivery.option.cancel')" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.createPersonName')"
              prop="instructionCreatePersonName"
            >
              <el-input v-model="formInline.instructionCreatePersonName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.companyName')"
              prop="instructionCompanyName"
            >
              <el-input v-model="formInline.instructionCompanyName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.instructionType')"
              prop="instructionType"
            >
              <ajax-select
                v-model="formInline.instructionType"
                :apiUrl="dictApi"
                :apiData="typeApiData"
                @change="instructionTypeChange"
              ></ajax-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.isDirectDeliver')"
              prop="directDeliver"
            >
              <el-select class="inputWidth" v-model="formInline.directDeliver" disabled>
                <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.notDirect')"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.deliverMethod')"
              prop="deliverMethod"
            >
              <el-select class="inputWidth" v-model="formInline.deliverMethod" disabled>
                <el-option
                  :label="$t('addSupplierDelivery.option.supplierSend')"
                  value="0"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.selfProduction')"
                  value="1"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.selfCustomer')"
                  value="2"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.libraryTurn')"
                  value="3"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('addSupplierDelivery.detail.baseInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-form
            :model="formBaseInfo"
            label-width="120px"
            ref="formBaseInfo"
            :rules="formBaseInfoRules"
            :validate-on-rule-change="false"
            :disabled="true"
          >
            <el-row>
              <el-col :span="6">
                <!-- 供应商 -->
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.partnerNo')"
                  prop="partnerName"
                >
                  <!-- 弹窗搜索-->
                  <search-table
                    v-model="formBaseInfo.partnerNo"
                    searchType="supplier"
                    :isMultiple="true"
                    :currentValue="formBaseInfo.partnerName ? formBaseInfo.partnerName : ''"
                    :checkRowKeys="formBaseInfo.partnerNo ? [formBaseInfo.partnerNo] : []"
                    @input="(val) => chooseForm(val, 'partnerNo')"
                  ></search-table>
                  <!-- <el-input v-model="formBaseInfo.partnerName" disabled></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.departmentNo')"
                  prop="instructionDepartmentName"
                >
                  <el-input v-model="formBaseInfo.instructionDepartmentName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 业务员 -->
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.salesmanNo')"
                  prop="salesmanNo"
                >
                  <!--弹窗搜索-->
                  <search-table
                    v-model="formBaseInfo.salesmanNo"
                    searchType="personnel"
                    :isMultiple="true"
                    :currentValue="formBaseInfo.salesmanName ? formBaseInfo.salesmanName : ''"
                    :checkRowKeys="formBaseInfo.salesmanNo ? [formBaseInfo.salesmanNo] : []"
                    @input="(val) => chooseForm(val, 'salesmanNo')"
                  ></search-table>
                </el-form-item>
              </el-col>
              <!-- 发货仓库 -->
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverFromStorageNo')"
                  prop="deliverFromStorageNo"
                >
                  <!--弹窗搜索-->
                  <search-table
                    v-model="formBaseInfo.deliverFromStorageNo"
                    searchType="warehouse"
                    :isMultiple="true"
                    :currentValue="
                      formBaseInfo.deliverFromStorageName ? formBaseInfo.deliverFromStorageName : ''
                    "
                    :checkRowKeys="
                      formBaseInfo.deliverFromStorageNo ? [formBaseInfo.deliverFromStorageNo] : []
                    "
                    @input="(val) => chooseForm(val, 'deliverFromStorageNo')"
                  ></search-table>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="dataGroupHN">
                <!-- 客户 -->
                <!-- 弹窗搜索 -->
                <!-- <search-table
                    v-model="formBaseInfo.partnerNo"
                    searchType="supplier"
                    v-if="formBaseInfo.contractDetailCategory=='HT04'"
                    :isMultiple="true"
                    :currentValue="formBaseInfo.partnerName? formBaseInfo.partnerName : ''"
                    :checkRowKeys="formBaseInfo.partnerNo ? [formBaseInfo.partnerNo] : []"
                    @input="(val) => chooseForm(val,'partnerNo')"
                  ></search-table>-->
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.customerName')"
                  prop="customerName"
                >
                  <el-input v-model="formBaseInfo.customerName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverFromAddress')"
                  prop="deliverFromAddress"
                >
                  <el-input v-model="formBaseInfo.deliverFromAddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.purchaseContractNo')"
                  prop="purchaseContractNo"
                >
                  <el-input v-model="formBaseInfo.purchaseContractNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.purchaseIntentNo')"
                  prop="purchaseIntentNo"
                >
                  <el-input v-model="formBaseInfo.purchaseIntentNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverDate')"
                  prop="deliverDate"
                >
                  <el-date-picker
                    class="inputWidth"
                    v-model="formBaseInfo.deliverDate"
                    type="date"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.expectArrivalDate')"
                  prop="expectArrivalDate"
                >
                  <el-date-picker
                    class="inputWidth"
                    v-model="formBaseInfo.expectArrivalDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="
                      this.$t('transportOrderAdd.pickUpForm.deliveryStartDatePlaceholder')
                    "
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 收货仓库 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverToStorageNo')"
                  prop="deliverToStorageNo"
                >
                  <search-table
                    v-model="formBaseInfo.deliverToStorageNo"
                    searchType="warehouse"
                    v-if="!formBaseInfo.flowDirection"
                    :isMultiple="true"
                    :currentValue="
                      formBaseInfo.deliverToStorageName ? formBaseInfo.deliverToStorageName : ''
                    "
                    :checkRowKeys="
                      formBaseInfo.deliverToStorageNo ? [formBaseInfo.deliverToStorageNo] : []
                    "
                    @input="(val) => chooseForm(val, 'deliverToStorageNo')"
                  ></search-table>
                  <el-input v-else disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.registrationNo')"
                  prop="registrationNo"
                >
                  <el-input v-model="formBaseInfo.registrationNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.externalContractNo')"
                  prop="externalContractNo"
                >
                  <el-input v-model="formBaseInfo.externalContractNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.shippingContact')"
                  prop="shippingContact"
                >
                  <el-input v-model="formBaseInfo.shippingContact"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.shippingContactPerson')"
                  prop="shippingContactPerson"
                >
                  <el-input v-model="formBaseInfo.shippingContactPerson"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.flowDirection')"
                  prop="flowDirection"
                >
                  <el-input
                    v-model="formBaseInfo.flowDirection"
                    :disabled="formBaseInfo.deliverToStorageNo ? true : false"
                    @input="changeFlowDirection"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 业务性质 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.businessMode')"
                  prop="businessMode"
                >
                  <ajax-select
                    v-model="formBaseInfo.businessMode"
                    :apiUrl="dictApi"
                    :apiData="operationModeData"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.distributionMode')"
                  prop="distributionMode"
                >
                  <ajax-select
                    v-model="formBaseInfo.distributionMode"
                    :apiUrl="dictApi"
                    :apiData="deliveryMethodData"
                    @change="distributionModeChange"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item :label="$t('addSupplierDelivery.detail.insured')" prop="insured">
                  <el-select class="inputWidth" v-model="formBaseInfo.insured" filterable>
                    <el-option
                      :label="$t('addSupplierDelivery.detail.insuredOptionOne')"
                      :value="1"
                    ></el-option>
                    <el-option
                      :label="$t('addSupplierDelivery.detail.insuredOptionTwo')"
                      :value="0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.marineLadingNo')"
                  prop="marineLadingNo"
                >
                  <el-input v-model="formBaseInfo.marineLadingNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.warehouseReceiptsNo')"
                  prop="warehouseReceiptsNo"
                >
                  <el-input v-model="formBaseInfo.warehouseReceiptsNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!dataGroupHN">
                <el-form-item label="货币" prop="currencyTypeCode">
                  <ajax-select
                    v-model="formBaseInfo.currencyTypeCode"
                    :apiUrl="currencyApi"
                    :apiData="currencyData"
                    :disabled="true"
                    valueKey="currencyCode"
                    moreShowKey="currencyCode"
                    labelKey="currencyName"
                    method="get"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="18" v-if="dataGroupHN">
                <el-form-item label="收货地址" prop="deliverToAddress">
                  <el-input v-model="formBaseInfo.deliverToAddress" maxlength="256" clearable>
                    <el-button slot="append" @click="chooseAddr">选择地址</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="收货备注" prop="shippingMark">
                  <el-input
                    v-model="formBaseInfo.shippingMark"
                    maxlength="256"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>

      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('addSupplierDelivery.detail.shoppingInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                @click="addPaymentApply()"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >创建付款申请</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            resizable
            v-if="showTable"
            show-overflow
            highlight-hover-row
            size="mini"
            ref="goodsTable"
            class="vxe-table-element"
            :edit-rules="goodsTableRules"
            :data="storageInstructionDetail"
            :edit-config="{}"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column type="seq" width="60"></vxe-table-column>
            <vxe-table-column
              field="purchaseContractDetailNo"
              width="150"
              :title="$t('addSupplierDelivery.detail.purchaseContractDetailNo')"
            ></vxe-table-column>
            <vxe-table-column
              :visible="!dataGroupHN"
              field="purchaseIntentDetailNo"
              width="150"
              :title="$t('addSupplierDelivery.detail.purchaseIntentDetailNo')"
            ></vxe-table-column>
            <!-- <vxe-table-column
              field="distributionBatchNo"
              :title="$t('logistics.commodityMarket.distributionBatchNo')"
              width="180"
            >
            </vxe-table-column> -->
            <vxe-table-column
              field="productNo"
              width="150"
              :title="$t('addSupplierDelivery.detail.productNo')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.productNo"
                  searchType="goodsDetail"
                  propName="productDetailCode"
                  :isMultiple="true"
                  :currentValue="scope.row.productNo ? scope.row.productNo : ''"
                  :checkRowKeys="scope.row.productNo ? [scope.row.productNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'productNo', scope)"
                ></search-table>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productDesc"
              width="150"
              :title="$t('addSupplierDelivery.detail.productDesc')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.productDesc"
                  searchType="goodsDetail"
                  propName="detailProductDisplayName"
                  :isMultiple="true"
                  :currentValue="scope.row.productDesc ? scope.row.productDesc : ''"
                  :checkRowKeys="scope.row.productNo ? [scope.row.productNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'productDesc', scope)"
                ></search-table>
              </template>
            </vxe-table-column>
            <!-- 签约数量 -->
            <vxe-table-column
              :visible="dataGroupHN"
              field="contractNo"
              :title="$t('addSupplierDelivery.detail.contractNo')"
              min-width="160"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.contractNo, $globalVar.qPoint)
              }}</template>
            </vxe-table-column>

            <vxe-table-column
              field="instructionNumber"
              :title="$t('addSupplierDelivery.detail.instructionNumber')"
              min-width="160"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.instructionNumber"
                  @input="$refs.goodsTable.updateStatus(scope)"
                  @blur="instructionNumberChange(scope.row.instructionNumber, scope.row, scope)"
                ></el-input>
              </template>
            </vxe-table-column>

            <vxe-table-column
              :visible="!dataGroupHN"
              field="overShippedPercentage"
              width="150"
              :title="$t('addSupplierDelivery.detail.overShippedPercentage')"
            ></vxe-table-column>
            <!-- 单位 -->
            <vxe-table-column
              field="unit"
              width="150"
              :title="$t('addSupplierDelivery.detail.unit')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <!-- <ajax-select v-model="scope.row.unit" :apiUrl="dictApi" :apiData="unitData"></ajax-select> -->
                <el-select v-model="scope.row.unit" filterable>
                  <el-option
                    v-for="item in unitOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
              <template v-slot="{ row }">{{ transferSelectLabel(row.unit, unitOptions) }}</template>
            </vxe-table-column>
            <vxe-table-column
              :visible="!dataGroupHN"
              field="packaging"
              :title="$t('addSupplierDelivery.detail.packaging')"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.packaging"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- 单位重量 -->
            <vxe-table-column
              :visible="!dataGroupHN"
              field="unitWeight"
              :title="$t('addSupplierDelivery.detail.unitWeight')"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.unitWeight"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="unitNumber"
              :title="$t('addSupplierDelivery.detail.unitNumber')"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.unitNumber"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>

            <vxe-table-column
              :visible="!dataGroupHN"
              field="packagingNumber"
              :title="$t('addSupplierDelivery.detail.packagingNumber')"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.packagingNumber"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- 包装单位 搜索弹窗 -->
            <vxe-table-column
              :visible="!dataGroupHN"
              field="packagingUnit"
              width="150"
              :title="$t('addSupplierDelivery.detail.packagingUnit')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <!-- <ajax-select
                  v-model="scope.row.packagingUnit"
                  :apiUrl="dictApi"
                  :apiData="unitData"
                ></ajax-select> -->
                <el-select v-model="scope.row.packagingUnit" filterable>
                  <el-option
                    v-for="item in unitOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
              <template v-slot="{ row }">{{
                transferSelectLabel(row.packagingUnit, unitOptions)
              }}</template>
            </vxe-table-column>
            <!-- 仓库 -->
            <vxe-table-column
              :visible="!dataGroupHN"
              field="storageName"
              width="150"
              :title="$t('addSupplierDelivery.detail.storageNo')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.storageName"
                  searchType="warehouse"
                  :isMultiple="true"
                  :currentValue="scope.row.storageName ? scope.row.storageName : ''"
                  :checkRowKeys="scope.row.storageNo ? [scope.row.storageNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'storageName', scope)"
                ></search-table>
              </template>
            </vxe-table-column>

            <vxe-table-column
              :visible="!dataGroupHN"
              field="mark"
              :title="$t('addSupplierDelivery.detail.mark')"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.mark"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- <vxe-table-column
              width="150"
              field="contractUnitPrice"
              :title="$t('addSupplierDelivery.detail.contractUnitPrice')"
            ></vxe-table-column>
            <vxe-table-column
              width="150"
              field="totalAmount"
              :title="$t('addSupplierDelivery.detail.totalAmount')"
            >
            <template v-slot="{ row }">{{$baseRequest.formatTableColumn(row.totalAmount, $globalVar.tPoint)}}</template>
            </vxe-table-column> -->
            <!-- 合同价格 -->
            <vxe-table-column
              width="150"
              field="contractUnitPrice"
              :title="
                dataGroupHN
                  ? $t('addSupplierDelivery.detail.contractUnitPriceHN')
                  : $t('addSupplierDelivery.detail.contractUnitPrice')
              "
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.contractUnitPrice, $globalVar.pPoint)
              }}</template>
            </vxe-table-column>
            <!-- 海宁运费单价 -->
            <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="shippingUnitExpense"
              :title="$t('addSupplierDelivery.detail.shippingUnitExpenseHN')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.shippingUnitExpense, $globalVar.pPoint)
              }}</template>
            </vxe-table-column>
            <!-- 金额 -->
            <vxe-table-column
              width="150"
              field="totalAmount"
              :title="
                dataGroupHN
                  ? $t('addSupplierDelivery.detail.totalAmountHN')
                  : $t('addSupplierDelivery.detail.totalAmount')
              "
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.totalAmount, $globalVar.aPoint)
              }}</template>
            </vxe-table-column>

            <!-- 销售单价 -->
            <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesContractUnitPrice"
              :title="$t('addSupplierDelivery.detail.salesContractUnitPrice')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesContractUnitPrice, $globalVar.pPoint)
              }}</template>
            </vxe-table-column>
            <!-- 销售运费单价 -->
            <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesShippingUnitExpense"
              :title="$t('addSupplierDelivery.detail.salesShippingUnitExpense')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesShippingUnitExpense, $globalVar.pPoint)
              }}</template>
            </vxe-table-column>
            <!-- 销售金额 -->
            <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesContractTotalAmount"
              :title="$t('addSupplierDelivery.detail.salesContractTotalAmount')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesContractTotalAmount, $globalVar.aPoint)
              }}</template>
            </vxe-table-column>
            <!-- 物流批次号 -->
            <vxe-table-column
              field="distributionBatchNo"
              title="物流批次号"
              min-width="120"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.distributionBatchNo"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></el-input>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </el-collapse-item>

      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('addSupplierDelivery.detail.transportInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-form ref="tableform" size="mini" label-width="60px">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.distributionMode')"
                  prop="distributionMode"
                >
                  <ajax-select
                    v-model="formBaseInfo.distributionMode"
                    :apiUrl="dictApi"
                    :apiData="deliveryMethodData"
                    :disabled="true"
                  ></ajax-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <vxe-table
            border
            resizable
            show-overflow
            highlight-hover-row
            size="mini"
            ref="xTable"
            class="vxe-table-element"
            :data="storageInstructionTransport"
            :edit-rules="transportDataRules"
            :edit-config="{}"
          >
            <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
            <vxe-table-column
              field="nameVoyageLicense"
              width="150"
              :title="$t('addSupplierDelivery.detail.vesselName')"
              :edit-render="{ name: 'ElInput' }"
            ></vxe-table-column>
            <vxe-table-column
              field="freightInformation"
              :title="$t('addSupplierDelivery.detail.freightInformation')"
              :edit-render="{ name: 'ElInput' }"
            ></vxe-table-column>
            <vxe-table-column
              field="contactPerson"
              :title="$t('addSupplierDelivery.detail.contactPerson')"
              :edit-render="{ name: 'ElInput' }"
            ></vxe-table-column>
            <vxe-table-column
              field="contactPhoneNo"
              :title="$t('addSupplierDelivery.detail.contactPhoneNo')"
              :edit-render="{ name: 'ElInput' }"
            ></vxe-table-column>
            <vxe-table-column
              field="identityCardNumber"
              :title="$t('addSupplierDelivery.detail.identityCardNumber')"
              :edit-render="{ name: 'ElInput' }"
            ></vxe-table-column>
          </vxe-table>
        </div>
      </el-collapse-item>

      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('returnDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            defaultPath="scm/warehouseContract"
            :tableData="storageAttachment"
            @upload="uploadList"
            :isShow="false"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 0已保存，1已确认，2已业务入库，3已撤销 -->
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        v-hasPermi="['2021042915510723653']"
        @click="save(0)"
        :disabled="showStatus == 1 || showStatus == 2"
        >{{ this.$t('addSupplierDelivery.detail.save') }}</el-button
      >
      <el-button
        @click="checkSave(1)"
        type="primary"
        :disabled="
          showStatus == 1 ||
          showStatus == 2 ||
          (formInline.directDeliver == '1' && formInline.deliverMethod != '1')
        "
        >{{ this.$t('addSupplierDelivery.detail.submiLogistics') }}</el-button
      >
      <!-- 运输格式打印 -->
      <el-button type="primary" @click="checkSave" :disabled="showStatus == 1 || showStatus == 2">{{
        this.$t('addSupplierDelivery.detail.transportPrint')
      }}</el-button>
      <el-button
        type="primary"
        @click="applayTransfer()"
        v-hasPermi="['2021042915515682556']"
        :disabled="showStatus == '' || !(formInline.deliverMethod == '1' && showStatus == '0')"
        >{{ this.$t('addSupplierDelivery.detail.applayTransfer') }}</el-button
      >
      <el-button
        type="primary"
        v-hasPermi="['2021042915522060245']"
        @click="checkSave(2)"
        :disabled="showStatus == 1 || formBaseInfo.directDeliver == '0'"
        >{{ this.$t('addSupplierDelivery.detail.createBusinessRepository') }}</el-button
      >
      <!-- 打印 -->
      <el-button
        :visible="dataGroupHN"
        type="primary"
        @click="print"
        v-if="showStatus == 1 || showStatus == 2"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.print') }}</el-button
      >
      <el-button
        type="primary"
        v-hasPermi="['2021042915525016277']"
        @click="withdraw"
        :disabled="showStatus != 1 && showStatus != 2"
        >{{ this.$t('addSupplierDelivery.detail.withdraw') }}</el-button
      >
      <el-button
        type="primary"
        v-hasPermi="['2021042915531474306']"
        @click="delte"
        :disabled="showStatus != 0 && showStatus != 3"
        >{{ this.$t('addSupplierDelivery.detail.delte') }}</el-button
      >
    </div>
    <!-- <uploadDialog ref="uploadDialog"></uploadDialog> -->

    <SelectTableDialog
      title="收货地址"
      :columnList="contractColumnList"
      :defaultVisible="defaultVisible"
      :API="addrAPI"
      :extraData="addrExtraData"
      :confirmUnchecked="false"
      :isMultiple="false"
      :type="addrType"
      :page="1 != 1"
      width="1200px"
      @close="close"
      @confirm="confirmAddr"
    >
    </SelectTableDialog>
    <print-dialog ref="printDialog"></print-dialog>
  </div>
</template>

<script>
  // import uploadDialog from "./uploadDialog"
  import Upload from '@/components/upload';
  // import SearchModal from '@/components/SearchModal';
  // import { async } from 'q';
  import { mapState } from 'vuex';
  import searchTable from '@/components/form-item/search-table';
  import ajaxSelect from '@/pages/wareHouse/stockManage/components/ajax-select';
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  import SelectTableDialog from '@/components/SelectTableDialog';
  // import BASE_API from '@/api/dataBase';
  import printDialog from '../components/printDialog';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      // SearchModal,
      // uploadDialog,
      searchTable,
      ajaxSelect,
      Upload,
      SelectTableDialog,
      printDialog,
    },
    name: 'supplierDeliveryDetail',
    data() {
      return {
        addrAPI: API.GET_PARTNER_PERSON,
        addrExtraData: {},
        defaultVisible: false,
        addrType: 'get',
        addrDataKey: 'partnersPersons',
        dataGroupHN: false, //判断订单是否来自海宁
        showTable: true,
        contractNo: '', //引用的采购合同号
        activeNames: ['1', '2', '3', '4'], //默认展开那些面板，
        dictApi: API.DATA_DICT, // TODO 测试api
        typeApiData: {},
        statusApiData: {},
        operationModeData: {},
        deliveryMethodData: {},
        unitData: {},
        currencyData: {},
        currencyApi: '', //货币种类api
        formInline: {
          //头部基本信息加上登陆信息和id/version
          id: '',
          version: '',
          tenantCode: '',
          companyCode: '',
          companyName: '',
          instructionCompanyNo: '', //供应商发货指令公司
          instructionCompanyName: '', //供应商发货指令公司
          departmentCode: '',
          departmentName: '',
          instructionNo: '',
          instructionStatus: '',
          instructionCreatePersonName: '',
          instructionType: '',
          directDeliver: '',
          deliverMethod: '',
          instructionCreateDate: '', //创建日期
        },
        formBaseInfo: {
          partnerNo: '',
          partnerName: '',
          customerName: '',
          customerNo: '',
          instructionDepartmentNo: '',
          instructionDepartmentName: '',
          salesmanNo: '',
          salesmanName: '',
          deliverFromAddress: '',
          deliverToStorageNo: '',
          deliverToStorageName: '',
          purchaseContractNo: '',
          purchaseIntentNo: '',
          deliverDate: '',
          expectArrivalDate: '',
          flowDirection: '',
          registrationNo: '',
          insured: '',
          externalContractNo: '',
          shippingContact: '',
          businessMode: '',
          distributionMode: '',
          deliverFromStorageNo: '',
          deliverFromStorageName: '',
          shippingContactPerson: '',
          marineLadingNo: '',
          warehouseReceiptsNo: '',
          shippingMark: '',
          deliverToAddress: '',
        },
        //load: false,
        storageInstructionDetail: [], //商品行项目信息
        storageInstructionTransport: [], //交通运输信息
        storageAttachment: [], //附件信息
        tableColumn: [
          {
            type: 'index',
            title: this.$t('addSupplierDelivery.detail.indexNum'),
            width: 80,
          },
          {
            field: 'purchaseContractDetailNo',
            title: this.$t('addSupplierDelivery.detail.purchaseContractDetailNo'),
            width: 150,
          },
          // {
          //   field: "purchaseIntentDetailNo",
          //   title: this.$t("addSupplierDelivery.detail.purchaseIntentDetailNo"),
          //   width: 150
          // },
          {
            field: 'productNo',
            title: this.$t('addSupplierDelivery.detail.productNo'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'productDesc',
            title: this.$t('addSupplierDelivery.detail.productDesc'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'instructionNumber',
            title: this.$t('addSupplierDelivery.detail.instructionNumber'),
            editRender: { name: 'ElInput' },
            width: 180,
          },
          {
            field: 'overShippedPercentage',
            title: this.$t('addSupplierDelivery.detail.overShippedPercentage'),
            width: 150,
          },
          {
            field: 'unit',
            title: this.$t('addSupplierDelivery.detail.unit'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'packaging',
            title: this.$t('addSupplierDelivery.detail.packaging'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'unitWeight',
            title: this.$t('addSupplierDelivery.detail.unitWeight'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'unitNumber',
            title: this.$t('addSupplierDelivery.detail.unitNumber'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'packagingNumber',
            title: this.$t('addSupplierDelivery.detail.packagingNumber'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'packagingUnit',
            title: this.$t('addSupplierDelivery.detail.packagingUnit'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'storageNo',
            title: this.$t('addSupplierDelivery.detail.storageNo'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'mark',
            title: this.$t('addSupplierDelivery.detail.mark'),
            editRender: { name: 'ElInput' },
            width: 150,
          },
          {
            field: 'distributionNo',
            title: this.$t('addSupplierDelivery.detail.distributionNo'),
            width: 150,
          },
        ],
        instructionNo: '', //接受的供应商发货指令
        showStatus: '', //按钮显示状态  0已保存，1已确认，2已业务入库，3已撤销
        judgetype: '',
        isShowBtn: '', //1编辑   2查看
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //单位下拉1
        unitOptions() {
          return this.$baseRequest.getDictListByType('basic_unit');
        },
      }),

      contractColumnList() {
        return [
          {
            prop: 'contactPersonName',
            label: '联系人',
          },
          {
            prop: 'address',
            label: '地址',
          },
        ];
      },
      formInlineRules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          // instructionNo: [
          //   {
          //     required: true,
          //     message: "请输入",
          //     trigger: "blur"
          //   }
          // ],
          instructionCreatePersonName: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          instructionCompanyName: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          instructionType: [
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          directDeliver: [
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          deliverMethod: [
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
        };
      },
      formBaseInfoRules() {
        let validator1 = (rule, value, callback) => {
          let fullData = this.$refs.goodsTable?.getTableData().fullData || [];
          let storageNoArr = [];
          fullData.map((item) => {
            if (!storageNoArr.includes(item.storageNo)) storageNoArr.push(item.storageNo);
          });
          if (storageNoArr.length > 1) {
            callback(new Error('行项目仓库不一致,请修改收货仓库'));
          } else {
            callback();
          }
        };
        return {
          deliverDate: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          expectArrivalDate: [
            {
              required: true,
              message: '请选择',
              trigger: ['blur', 'change'],
            },
          ],
          partnerName: [
            {
              required: true,
              message: '请选择',
              trigger: ['blur'],
            },
          ],
          instructionDepartmentName: [
            {
              required: true,
              message: '请输入',
              trigger: ['blur'],
            },
          ],
          deliverToStorageNo: [
            {
              required: this.formBaseInfo.deliverToStorageNo ? true : false,
              message: '请选择',
              trigger: ['blur'],
            },
            {
              validator: validator1,
            },
          ],
          businessMode: [
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ],
          flowDirection: [
            {
              required: this.formBaseInfo.flowDirection ? true : false,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ],

          deliverFromAddress: [
            {
              required: this.formInline.deliverMethod == '1' ? true : false,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          distributionMode: [
            {
              required: true,
              message: '请选择',
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
      goodsTableRules() {
        return {
          productNo: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          productDesc: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          instructionNumber: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          unit: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          storageNo: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
        };
      },
      transportDataRules() {
        if (this.formInline.deliverMethod == '0' && this.formInline.directDeliver == '0') {
          //非直拨  供应商配送
          return {
            nameVoyageLicense: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            freightInformation: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            contactPerson: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            contactPhoneNo: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            identityCardNumber: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
          };
        } else {
          return {};
        }
      },
    },
    created() {
      const tenantCode = this.userInfo.tenantCode;
      this.typeApiData = { dictType: 'instruction_type', tenantCode };
      this.operationModeData = { dictType: 'purchase_business_type', tenantCode };
      this.deliveryMethodData = { dictType: 'delivery_method', tenantCode };
      this.statusApiData = { dictType: 'request_status', tenantCode };
    },
    mounted() {
      this.judge();
      this.currencyApi = API.LIST_CURRENCY;
    },
    methods: {
      chooseAddr() {
        this.defaultVisible = true;
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 弹窗确认
      confirmAddr(selections) {
        this.formBaseInfo.deliverToAddress = selections[0].address;
        this.defaultVisible = false;
      },
      // sxp add 20210120 创建付款申请
      addPaymentApply() {
        const selectedList = this.$refs.goodsTable.getSelectRecords(); // 获取选中数据
        if (selectedList.length == 0) {
          return this.$message({ showClose: true, message: '请至少选择一条数据！', type: 'error' });
        }
        let params = { storageInstructionDetail: JSON.stringify(selectedList) };
        [
          'id',
          'version',
          'tenantCode',
          'companyCode',
          'companyName',
          'departmentCode',
          'instructionCompanyNo',
          'instructionCompanyName',
          'departmentName',
          'instructionNo',
        ].map((item) => {
          params[item] = this.formInline[item];
        });
        let path = {
          path: '/payment/paymentApplyAdd',
          name: 'paymentApplyAdd',
          meta: {
            keepAlive: true,
            title: '付款申请单创建',
          },
          query: {
            isEdit: 'Y',
            enterName: 'SUPPLIERDELIVERY', // 入口名称
            params: JSON.stringify(params),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //表单下拉表格赋值
      chooseForm(val, field) {
        if (field === 'partnerNo') {
          //供应商
          const partner = val ? val[0] : null;
          if (partner) {
            this.formBaseInfo.partnerName = partner.partnerZhName;
            this.formBaseInfo.partnerNo = partner.partnerCode;
          } else {
            //重置
            this.formBaseInfo.partnerName = '';
            this.formBaseInfo.partnerNo = '';
          }
        } else if (field === 'salesmanNo') {
          //业务员
          const salesman = val ? val[0] : null;
          if (salesman) {
            this.formBaseInfo.salesmanName = salesman.salesmanName;
            this.formBaseInfo.salesmanNo = salesman.salesmanNo;
          } else {
            this.formBaseInfo.salesmanName = '';
            this.formBaseInfo.salesmanNo = '';
          }
        } else if (field === 'deliverFromStorageNo') {
          //发货仓库
          const wareHouse = val ? val[0] : null;
          if (wareHouse) {
            this.formBaseInfo.deliverFromStorageNo = wareHouse.storageCode;
            this.formBaseInfo.deliverFromStorageName = wareHouse.storageName;
          } else {
            this.formBaseInfo.deliverFromStorageNo = '';
            this.formBaseInfo.deliverFromStorageName = '';
          }
        } else if (field === 'deliverToStorageNo') {
          //收货仓库
          const wareHouse = val ? val[0] : null;
          if (wareHouse) {
            this.formBaseInfo.deliverToStorageNo = wareHouse.storageCode;
            this.formBaseInfo.deliverToStorageName = wareHouse.storageName;
          } else {
            //重置
            this.formBaseInfo.deliverToStorageNo = '';
            this.formBaseInfo.deliverToStorageName = '';
            this.$refs.formBaseInfo.clearValidate('deliverToStorageNo');
          }
        }
      },
      //表格下拉表格赋值
      chooseTable(val, row, field, scope) {
        if (field === 'productNo' || field === 'productDesc') {
          //商品
          const product = row[field] ? row[field][0] : null;
          //如果没有选产品 则不走下面的逻辑
          if (product) {
            row.productNo = product.productDetailCode || null;
            row.productDesc = product.detailProductDisplayName;
          }
        } else if (field === 'storageName') {
          //仓库
          const wareHouse = row[field] ? row[field][0] : null;
          //如果没有选产品 则不走下面的逻辑
          if (wareHouse) {
            row.storageNo = wareHouse.storageCode || null;
            row.storageName = wareHouse.storageName;
          }
        }
        this.$refs.goodsTable.updateStatus(scope);
      },
      //流向发生变化
      changeFlowDirection() {
        this.$refs.formBaseInfo.clearValidate('deliverToStorageNo');
      },
      //供应商发货指令数量行发生变化
      instructionNumberChange(val, row, scope) {
        if (val) {
          //如果有数量 则计算
          //row.totalAmount = val * row.contractUnitPrice;
          const params = {
            returnQuantity: val,
            returnUnitPrice: row.contractUnitPrice,
          };
          this.$axios.post(API.CALC_AMOUNT_API, params).then((res) => {
            if (0 == res.data.code) {
              row.totalAmount = res.data.data.returnMoneyAmount;
            }
          });
        }
        this.$refs.goodsTable.updateStatus(scope);
      },

      //下拉表格的清空
      resetModelFun(obj) {
        if (obj.propCode == 'storageCode') {
          this.formBaseInfo.deliverToStorageNo = '';
        }
      },
      judge() {
        this.judgetype = this.$route.query.type;
        this.isShowBtn = this.$route.query.flag;
        if (this.judgetype == 2) {
          //双击跳转过来
          this.instructionNo = this.$route.query.instructionNo;
          this.getDetail();
        } else {
          //新增时候 查询合同详情并给商品行项目信息赋值
          this.contractNo = this.$route.query.contractNo;
          this.formInline.instructionCreatePersonName = this.userInfo.userName;
          this.formInline.instructionCreateDate = new Date();
          this.formBaseInfo.deliverDate = new Date();
          this.formInline.instructionCreatePersonName = this.userInfo.userName;
          this.formInline.tenantCode = this.userInfo.tenantCode;
          this.formInline.companyCode = this.userInfo.companyCode;
          this.formInline.companyName = this.userInfo.companyName;
          this.formInline.departmentCode = this.userInfo.departmentCode;
          this.formInline.departmentName = this.userInfo.departmentName;
          this.getGoodsDetail();
        }
      },
      //新增的时候获取 选中采购合同的商品行（多行）数据
      getGoodsDetail() {
        this.loading.startLoading();
        this.$axios
          .get(API.DETAIL_ORDER_API + this.contractNo)
          .then((res) => {
            if (0 == res.data.code) {
              this.storageInstructionDetail = res.data.data.orderDetailList;
              this.storageInstructionDetail.map((item) => {
                if (res.data.data.isIntention == '1') {
                  //意向单
                  item.purchaseIntentDetailNo = item.contractDetailNo;
                } else {
                  //合同
                  item.purchaseContractDetailNo = item.contractDetailNo;
                }
                item.contractUnitPrice = item.businessContractUnitPrice;
                item.instructionNumber = item.deliverableQuantity;
                item.totalAmount = item.deliverableTotalAmount;
                item.purchaseContractNo = item.contractNo;
                item.contractNo = item.productQuantity;
                item.overShippedPercentage = res.data.data.overShippedPercentage;
              });
              this.formBaseInfo.partnerName = res.data.data.supplierName; //供应商
              this.formBaseInfo.partnerNo = res.data.data.supplierNo;
              if (this.dataGroupHN) {
                this.formBaseInfo.customerName = res.data.data.customerName; //客户
                this.formBaseInfo.customerNo = res.data.data.customerCode;
              }
              this.formBaseInfo.instructionDepartmentName = res.data.data.departmentName; //部门
              this.formBaseInfo.instructionDepartmentNo = res.data.data.departmentCode;
              this.formBaseInfo.salesmanNo = res.data.data.contractSalesmanNo; //业务员
              this.formBaseInfo.salesmanName = res.data.data.contractSalesmanName;
              this.formBaseInfo.currencyTypeCode = res.data.data.contractCurrency; //货币
              this.formBaseInfo.currencyTypeName = res.data.data.contractCurrencyName;
              //this.formBaseInfo.deliverToStorageNo = res.data.data.contractSalesmanN;//收货仓库
              //this.formBaseInfo.deliverToStorageName = res.data.data.contractSalesmanName;//收货仓库
              if (res.data.data.isIntention == '1') {
                //是 是否是意向单
                this.formBaseInfo.purchaseContractNo = ''; //采购合同号、
                this.formBaseInfo.purchaseIntentNo = res.data.data.contractNo;
              } else {
                //合同
                this.formBaseInfo.purchaseContractNo = res.data.data.contractNo; //采购合同号、
                this.formBaseInfo.purchaseIntentNo = '';
              }
              this.formBaseInfo.externalContractNo = res.data.data.externalContractNo; //外部合同号
              // 设置获取供应商详情参数
              this.addrExtraData = {
                partnerCode: this.formBaseInfo.customerNo,
                departmentCode: this.formBaseInfo.instructionDepartmentNo,
              };
              this.loading.endLoading();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },

      //获取详情
      getDetail() {
        this.loading.startLoading();
        this.showTable = false;
        this.$axios
          .get(API.DETAIL_DATA_API + this.instructionNo)
          .then((res) => {
            if (0 == res.data.code) {
              console.log(res.data);
              this.showStatus = res.data.data.instructionStatus;
              this.dataGroupHN = res.data.data.dataGroup == 'hn';
              this.showTable = true;
              //forminline信息赋值
              const {
                id,
                version,
                tenantCode,
                companyCode,
                companyName,
                instructionCompanyNo, //供应商发货指令公司
                instructionCompanyName, //供应商发货指令公司
                departmentCode,
                departmentName,
                instructionNo,
                instructionStatus,
                instructionCreatePersonName,
                instructionType,
                directDeliver,
                deliverMethod,
                instructionCreateDate,
              } = res.data.data;
              this.formInline = {
                id,
                version,
                tenantCode,
                companyCode,
                companyName,
                instructionCompanyNo, //供应商发货指令公司
                instructionCompanyName, //供应商发货指令公司
                departmentCode,
                departmentName,
                instructionNo,
                instructionStatus,
                instructionCreatePersonName,
                instructionType,
                directDeliver,
                deliverMethod,
                instructionCreateDate,
              };
              //forminBase信息赋值
              const {
                partnerNo,
                partnerName,
                customerName,
                customerNo,
                instructionDepartmentNo,
                instructionDepartmentName,
                salesmanNo,
                salesmanName,
                deliverFromAddress,
                deliverToStorageNo,
                deliverToStorageName,
                purchaseIntentNo,
                deliverDate,
                expectArrivalDate,
                flowDirection,
                registrationNo,
                insured,
                externalContractNo,
                shippingContact,
                businessMode,
                distributionMode,
                deliverFromStorageNo,
                deliverFromStorageName,
                shippingContactPerson,
                marineLadingNo,
                warehouseReceiptsNo,
                purchaseContractNo,
                shippingMark,
                currencyTypeCode,
              } = res.data.data;
              this.formBaseInfo = {
                partnerNo,
                partnerName,
                customerName,
                customerNo,
                instructionDepartmentNo,
                instructionDepartmentName,
                salesmanNo,
                salesmanName,
                deliverFromAddress,
                deliverToStorageNo,
                deliverToStorageName,
                purchaseIntentNo,
                deliverDate,
                expectArrivalDate,
                flowDirection,
                registrationNo,
                insured,
                externalContractNo,
                shippingContact,
                businessMode,
                distributionMode,
                deliverFromStorageNo,
                deliverFromStorageName,
                shippingContactPerson,
                marineLadingNo,
                warehouseReceiptsNo,
                purchaseContractNo,
                shippingMark,
                currencyTypeCode,
              };
              //三个列表信息赋值
              this.storageAttachment = res.data.data.storageAttachments;
              this.storageInstructionTransport = res.data.data.storageInstructionTransports;
              this.storageInstructionDetail = res.data.data.storageInstructionDetails;
              this.formInline.version = res.data.data.version;
              this.$refs.formInline.clearValidate();
              // 设置获取供应商详情参数
              this.addrExtraData = {
                partnerCode: this.formBaseInfo.customerNo,
                departmentCode: this.formBaseInfo.instructionDepartmentNo,
              };
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //发货指令类型的变更
      instructionTypeChange(val) {
        if (val == 'ZL01') {
          //非直拨-供应商配送
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '0';
        } else if (val == 'ZL02') {
          //非直拨-物产自提
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '1';
        } else if (val == 'ZL03') {
          //非直拨-库转
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '3';
        } else if (val == 'ZL04') {
          //直拨-供应商配送
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '0';
        } else if (val == 'ZL05') {
          //直拨-客户自提
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '2';
        } else if (val == 'ZL06') {
          //直拨-物产自提
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '1';
        }
      },
      //运输方式变更
      distributionModeChange(val) {
        console.log(val);
      },
      //新增
      insertEvent() {
        let record = {
          nameVoyageLicense: '',
          freightInformation: '',
          contactPerson: '',
          contactPhoneNo: '',
          identityCardNumber: '',
        };
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      //删除
      remove() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$alert('请至少选择一条数据！');
        }
      },
      //上传
      upload() {
        this.$refs.uploadDialog.openDialog(true, this.formInline.instructionNo, this.isShowBtn);
      },
      //1提交物流 2生成业务入库单 需校验必填
      checkSave(val) {
        let formArr = ['formInline', 'formBaseInfo']; //两个表单/一个表格
        var resultArr = []; //用来接受返回结果的数组
        var _self = this;
        function checkForm(formName) {
          //封装验证表单的函数
          var result = new Promise(function (resolve, reject) {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result); //push 得到promise的结果
        }
        formArr.forEach((item) => {
          //根据表单的ref校验
          checkForm(item);
        });
        Promise.all(resultArr)
          .then(function () {
            //都通过了
            _self.save(val);
          })
          .catch(function () {
            // console.log("err");
          });
      },
      //发货指令保存/提交物流/生成业务入库单
      save(val) {
        this.storageInstructionDetail = this.$refs.goodsTable.getTableData().fullData;
        this.storageInstructionTransport = this.$refs.xTable.getTableData().fullData;
        let obj = {};
        obj = Object.assign(
          obj,
          this.formBaseInfo,
          this.formInline,
          {
            storageInstructionDetail: JSON.stringify(this.storageInstructionDetail),
          },
          {
            storageInstructionTransport: JSON.stringify(this.storageInstructionTransport),
          },
          { instructionStatus: val }
        );

        this.loading.startLoading();
        //判断是不是已业务入库
        if (this.formInline.instructionStatus == '2') {
          let params = {
            contractNo: '',
            instructionNo: this.formInline.instructionNo,
          };
          if (this.formBaseInfo.purchaseContractNo) {
            params.contractNo = this.formBaseInfo.purchaseContractNo;
          } else {
            params.contractNo = this.formBaseInfo.purchaseIntentNo;
          }
          let vals = {
            instructionNo: this.formInline.instructionNo,
            contractNo: this.formBaseInfo.purchaseContractNo || this.formBaseInfo.purchaseIntentNo,
          };
          this.loading.endLoading();
          //生成业务入库
          this.goToOtherMoudles(vals);

          /* this.$axios
          .post(API.GET_EXIT_REST_INBOUND, params)
          .then(res => {
            if (res.data.data) {
              if (val == "2") {
                //生成业务入库
                this.goToOtherMoudles(vals);
              } else {
                this.returnPath();
              }
            } else {
              this.$message({
                showClose: true,
                message: '已完全业务入库',
                type: "error"
              });
            }
          })
          .finally(() => this.loading.endLoading()); */
        } else {
          this.$axios
            .post(API.SAVE_DATA_API, { ...obj, businessGroup: this.userInfo.businessGroup })
            .then((res) => {
              if (0 == res.data.code) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                if (val == '2') {
                  //生成业务入库
                  this.goToOtherMoudle(res.data.data);
                } else {
                  this.returnPath();
                }
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .finally(() => this.loading.endLoading());
        }
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/wareHouse/supplierDeliveryOrder',
            name: 'supplierDeliveryOrder',
            meta: {
              keepAlive: false,
              title: '供应商发货指令',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转生成业务入库
      goToOtherMoudle(val) {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: false,
              title: '业务入库',
            },
            query: {
              shipNo: val.instructionNo,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转生成业务入库
      goToOtherMoudles(val) {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: false,
              title: '业务入库',
            },
            query: {
              shipNo: val.instructionNo,
              contractNo: val.contractNo,
              sourceType: '1',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //撤销
      withdraw() {
        let obj = {
          instructionNo: this.formInline.instructionNo,
          version: this.formInline.version,
        };
        this.loading.startLoading();
        this.$axios
          .post(API.BACK_OUT_API, { ...obj, businessGroup: this.userInfo.businessGroup })
          .then((res) => {
            if (0 == res.data.code) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //删除
      delte() {
        let obj = {
          instructionNo: this.formInline.instructionNo,
          version: this.formInline.version,
        };
        this.loading.startLoading();
        this.$axios
          .post(API.DEL_DATA_API, obj)
          .then((res) => {
            if (0 == res.data.code) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //申请运输
      applayTransfer() {
        // if (this.formInline.deliverMethod != '1') {//不是物产自提
        //   this.$message({
        //     showClose: true,
        //     message: '只有发货方式为物产自提可以提交运输信息至物流',
        //     type: "error"
        //   });
        //   return
        // }
        const {
          tenantCode,
          companyCode,
          departmentCode,
          companyName,
          departmentName,
          instructionCreatePersonName,
        } = this.formInline;
        let obj = {
          instructionNo: this.formInline.instructionNo,
          version: this.formInline.version,
          instructionCreatePersonNo: this.userInfo.userCode,
          tenantCode,
          companyCode,
          departmentCode,
          companyName,
          departmentName,
          instructionCreatePersonName,
        };
        this.loading.startLoading();
        this.$axios
          .post(API.SAVE_TRANSPORT_API, obj)
          .then((res) => {
            if (0 == res.data.code) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //更新附件列表
      uploadList(value) {
        this.storageAttachments = [];
        if (value.length) {
          value.map((item, index) => {
            this.storageAttachments.push({
              ...item,
              sortNo: index,
            });
          });
        }
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true, this.formInline.instructionNo);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .addSupplierDelivery .topFrom {
    padding: 26px 20px 8px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
    margin-bottom: 10px;
  }
  .addSupplierDelivery .inputWidth {
    width: 100% !important;
  }
</style>
